export class ChangedSpaceEvent {
  public pmap_id: string;
  public pmapv_id: string;
  public change_type: string;
  public mission_number: number;
  public mission_timestamp: number;
}
